<div class="dataset-group" [class.expanded]="isExpanded()">
  <div class="dataset-group-toggle" data-cy="DatasetGroup" (click)="toggleExpanded($event)">
    <mat-icon class="icon dataset" [svgIcon]="icon()" />
    <ng-content select="title" />
    <button
      (click)="toggleExpanded($event)"
      blazeIconButton
      class="bg-base-transparent ml-auto"
      data-cy="DatasetGroup:toggle"
    >
      <mat-icon svgIcon="icon_chevron_down_16" [ngClass]="{ 'rotate-180': isExpanded() }" />
    </button>
  </div>
  @if (isExpanded()) {
    <div class="dataset-group-tables">
      <ng-content select="tables" />
    </div>
  }
</div>
